<template>
  <div>
    <appBuilding :is-new="true" />
  </div>
</template>

<script>
import appBuilding from "@/components/catalogs/buildings/Building";

export default {
  components: {
    appBuilding,
  },
};
</script>
